<template>
  <v-main class="page-travel-map">
    <AppBar :back="customBack" :hide-back="false" hide-background extension-height="30px">
      <template #end>
        <v-btn v-if="isDestination" icon plain :ripple="false" @click="destinationSheetStatus(true)">
          <IconBgChange/>
        </v-btn>
      </template>
      <div class="date spacer text-center">
        <template v-if="useStatus == '02'">중지기간 ({{ stopStrDt }} ~ {{ stopEndDt }})</template>
        <template v-else>({{ usagePeriodYmd }})</template>
      </div>
    </AppBar>
    <v-layout fill-height column class="travel-map">
      <v-container flex-fill>
        <div class="d-flex flex-column fill-height pos-relative z-1">
          <div v-for="i in forlen" :key="i" class="mission-list" :class="{ 'pb-0' : i === forlen }">
            <div v-for="j in lenArr[i-1]" :key="j"
                 :class="[{'current': progYn == 'Y' && weekday == ((i-1)*10)+j}
                            , {'complete': resultList[((i-1)*10)+j-1].cmpltYn === 'Y'}
                            , {'incomplete': resultList[((i-1)*10)+j-1].cmpltYn === 'O' && weekday != ((i-1)*10)+j}
                            , 'mission'
                            , {'mb-n5': i === forlen && j === lenArr[i-1]}
                            ]"
                 @click="scheduleSheetOpen(((i-1)*10)+j - 1)"
                 :ref="progYn == 'Y' && weekday == ((i-1)*10)+j ? 'current' : null"
            >
              {{ ((i - 1) * 10) + j }}
            </div>
          </div>
        </div>
        <!-- 여행지 변경-->
        <TravelDestinationSheet :ordDtlList="ordDtlList" :sheet="destinationSheet" @travelMapChange="getTravelMapList"
                                @sheetClose="destinationSheetStatus(false)"/>
        <!-- 일정변경-->
        <ScheduleChangeSheet ref="ScheduleChangeSheet" :useStatus="useStatus" :progYn="progYn" :ordDtlNo="ordDtlNo" :resultList="resultList" :weekday="weekday"/>
      </v-container>
      <v-footer app height="108px" color="transparent" class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large str="검사 결과보기" @click="goTravelPage"/>
        </div>
      </v-footer>
    </v-layout>
    <v-img class="travel-map-bg" v-if="bgImg" position="center top" :src="getImage(bgImg)"/>
  </v-main>
</template>
<script>
import store from '@/store'
import BlackBtn from "../../components/btns/BlackBtn.vue"
import IconBgChange from '../../components/icons/BgChange.vue'
import TravelDestinationSheet from "../../components/layout/bottomSheet/TravelDestinationSheet.vue"
import ScheduleChangeSheet from "../../components/layout/bottomSheet/ScheduleChangeSheet.vue"
import {mixinTrial} from "@/mixins";
import Util from '@/utils/utils'

export default {
  data: () => ({
    isDestination: true,
    destinationSheet: false,
    scheduleSheet: false,
    week: 0,
    day: 0,
    weekday: 0,
    ordDtlList: [],
    ordDtlNo: 0,
    sltUseNo: 0,
    forlen: 0,   // 전체 반복
    lenArr: [],  // 하위 반복
    resultList: [],
    // selected: 0,
    bgImgSamsungArr: ['hill', 'mountain', 'sea', 'mind', 'desert', 'space'],
    bgImgArr: ['hill', 'mountain', 'sea', 'mind', 'desert', 'space'],
    bgImg: '',
    progYn: 'Y',
    strDt: '',
    endDt: '',
    stopStrDt: '',
    stopEndDt: '',
    // goTravelApplStepCd: '0001',
    goTravelApplStepCd: '', // 여행지원서 결과
    clientCd: '',
    // dialog: false,
    // modalText:'',
    useStatus: ''
  }),
  components: {
    BlackBtn,
    IconBgChange,
    TravelDestinationSheet,
    ScheduleChangeSheet,
  },
  mixins: [mixinTrial],
  computed: {
    usagePeriodYmd () {
      if (this.hasActiveTrial) {
        const strDt = Util.Date.toFormatDate(this.trialActiveDateTime, 'YYYY.MM.DD')
        const endDt = Util.Date.toFormatDate(this.trialInactiveDateTime, 'YYYY.MM.DD')
        if (this.expiredTrial) return `${strDt} ~`
        return `${strDt} ~ ${endDt}`
      }
      else {
        return `${this.strDt} ~ ${this.endDt}`
      }
    },
  },
  mounted() {
    this.getTravelMapOrdDtlList()   // 주문정보 리스트 조회
  },
  created() {
    this.clientCd = this.$store.state.auth.authUser.clientCd
  },
  watch: {
    ordDtlNo (nv) {
      if (nv !== 0) {
        this.getMemberApplResultLast()  // 여행지원서 결과
      }
    }
  },
  methods: {
    customBack() {
      this.movePage('/');
      return false;
    },
    setOrdDtl (ordDtl) {
      this.useStatus = ordDtl.useStatus
      this.progYn = ordDtl.progYn

      // 트라이얼 상태일 경우
      if (this.hasActiveTrial) {
        this.endDt = Util.Date.toFormatDate(this.trialInactiveDateTime, 'YYYY.MM.DD')
        this.strDt = Util.Date.toFormatDate(this.trialActiveDateTime, 'YYYY.MM.DD')
      }
      else {
        this.endDt = ordDtl.usePeriodEndDt
        this.strDt = ordDtl.usePeriodStartDt
      }

      if (this.useStatus == '02') {
        this.stopStrDt = ordDtl.useStopStartDtSt
        this.stopEndDt = ordDtl.useStopEndDtSt
      }
      this.ordDtlNo = ordDtl.ordDtlNo
      // 현재 여행지 회차 구하기
      // const startDt = moment(ordDtl.usePeriodStartDt)
      // const today = moment()
      // const diff = today.diff(startDt, 'days') + 1    // 시작일자 포함
      this.weekday = (this.hasActiveTrial && this.expiredTrial) ? this.trialDays : ordDtl.weekDay
    },
    async getTravelMapOrdDtlList() {
      await store.dispatch('getTravelMapOrdDtlList', this.$_payload('so', [{'ordStatus': '01'}, {'ordDtlStatus': '01'}]))
          .then(res => {
            if (res.success) {
              const moment = require('moment')
              let index = 0
              if (this.$route.params.beforeOrdDtlNo) {
                index = res.data.findIndex((item) => {
                  // return item.ordDtlNo == '539'
                  return item.ordDtlNo == this.$route.params.beforeOrdDtlNo
                  // return item.ordDtlNo == '505'
                })
                if (index < 0 || index >= res.data.length) {
                  index = 0
                }
              }

              this.ordDtlList = res.data

              if (this.ordDtlList.length < 2 && this.clientCd == 'samsungfire') {
                this.isDestination = false
              }

              this.ordDtlList.forEach((result) => {
                result.usePeriodStartDt = moment(result.usePeriodStartDt).format('YYYY.MM.DD')
                result.usePeriodEndDt = moment(result.usePeriodEndDt).format('YYYY.MM.DD')
              });


              this.setOrdDtl(this.ordDtlList[index])
              // 사용솔루션번호로 솔루션 주차별 정보 조회(티켓정보 넘겨서 조회하는걸로 변경할지 고민)
              this.getTravelMapList(this.ordDtlList[index])

            } else {
              // this.answer = [];
            }
          })
          .catch(error => {
            console.error(error)
            // this.answer = [];
          })
          .finally(() => {
          })

    },
    async getTravelMapList(ordDtl) {
      this.setOrdDtl(ordDtl)
      await store.dispatch('getTravelMapList', this.$_payload({ordDtlNo: ordDtl.ordDtlNo}))
          .then(res => {
            if (res.success) {

              const moment = require('moment')

              this.resultList = res.data

              // 반복문 계산구간
              this.forlen = Math.ceil(this.resultList.length / 10)
              let len = this.resultList.length

              // 초기화
              this.lenArr.splice(0, this.lenArr.length)

              for (let i = 0; i < this.forlen; i++) {
                if (len > 10) {
                  this.lenArr.push(10)
                  len -= 10
                } else {
                  this.lenArr.push(len)
                }
              }

              // 배경이미지 구하기 -- 총 주문정보 수 기준으로
              // console.log("this.ordDtlList : ", this.ordDtlList)

              // 과거 여행지 주문번호인경우
              let bgindex = this.ordDtlList.findIndex((item) => {
                // return item.ordDtlNo === '13'
                return item.ordDtlNo == ordDtl.ordDtlNo
              });
              if (bgindex >= 0) {
                // console.log("bgindex : ", bgindex)
                bgindex = this.ordDtlList.length - bgindex
                bgindex = bgindex % 6
                if (bgindex == 0) {
                  bgindex = 6
                }
                // console.log("bgindex : ", bgindex)
                this.bgImg = 'background/' + this.bgImgArr[bgindex - 1]

                // 밤낮 구분으로 배경 변경
                const time = moment().format('HHmm')
                // const time = '0201'
                // console.log("time : ", time)
                if (time > '0700' && time <= '2000') {
                  this.bgImg = this.bgImg + '/day.png'
                } else {
                  this.bgImg = this.bgImg + '/night.png'
                }
              }

              //선택값 초기화
              // this.selected = 0
              if (this.$route.query.selected) {
                this.$refs.ScheduleChangeSheet.openSheet(Number(this.$route.query.selected), this.resultList)
              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
            if (this.$refs.current.length > 0) { // 현 여행지 현일차로 앵커처리
              const { selected } = this.$route.query
              if (selected) {
                const missionElements = [...document.body.querySelectorAll('.mission')];
                missionElements.map(element => {
                    if (element.textContent.trim() * 1 === (selected *1) + 1) {
                        element.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                });
             } else {
                this.$refs.current[0].scrollIntoView({behavior: "smooth", block: "center"})
              }
            } else { // 현일차가 존재하지 않을경우 (과거여행지) 최상단으로
              window.document.body.querySelector('.page-travel-map').scrollIntoView({behavior: "smooth"})
            }
          })
    },
    destinationSheetStatus(flag) {
      this.destinationSheet = flag;
    },
    scheduleSheetOpen(selected) {
      this.$router.replace({ query: { selected }}).catch(()=>{})
      this.$refs.ScheduleChangeSheet.openSheet(selected)
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}, {'ordDtlNo': this.ordDtlNo}]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                this.goTravelApplStepCd = res.data.travelApplStepCd;
              }
            } else {
              console.log(res.msg);
            }
          })
          .catch(error => {
            console.error(error);
            // this.isApplResult = false;
          })
          .finally(() => {
            store.commit('setInitApplResult', false)
          })
    },
    goTravelPage() {
      this.$router.push({
        name: "travelIntro",
        query: {travelApplStepCd: this.goTravelApplStepCd, startType: 'S', isTravelMap: true, ordDtlNo: this.ordDtlNo}
      });
    }
  }
}
</script>
